import { useState, FC } from "react";
import { Album } from "./types";
import { submitAlbumName } from "../API/api";
import {
  validateName,
  restrictedTermsError
} from "../../../utils/validateName";
import $ from "jquery";

export const useEditAlbumName = (
  updateAlbumsList: (album: any) => void,
  setAlbumsData: (album: Album[]) => void,
  albumsData: Album[] | null = null,
  onEditSuccessUpdateAlbum?: (album: Album) => void
) => {
  const [albumNameDrafts, setAlbumNameDrafts] = useState<{
    [key: number]: string;
  }>({});
  const [albumsInEditMode, setAlbumsInEditMode] = useState<number[]>([]);

  const toggleEditMode = (
    e: any,
    albumId: number,
    enterEditMode: boolean,
    name: string
  ) => {
    e.stopPropagation();
    if (enterEditMode) {
      $('.tooltip').remove();
      setAlbumsInEditMode(prev => [...prev, albumId]);
      setAlbumNameDrafts(prev => ({
        ...prev,
        [albumId]: name
      }));
    } else {
      setAlbumsInEditMode(prev => prev.filter(id => id !== albumId));
      setAlbumNameDrafts(prev => {
        const copy = { ...prev };
        delete copy[albumId];
        return copy;
      });
    }
  };

  const onEditSuccess = (
    updatedData: Album | Album[],
    editedAlbumId?: number
  ) => {
    const updatedAlbums = Array.isArray(updatedData)
      ? updatedData
      : [updatedData];

    let updatedAlbum: Album;
    if (!Array.isArray(updatedData)) {
      updatedAlbum = updatedData;
    } else {
      if (editedAlbumId !== undefined) {
        updatedAlbum =
          updatedAlbums.find(album => album.id === editedAlbumId) ||
          updatedAlbums[0];
      } else {
        updatedAlbum = updatedAlbums[0];
      }
    }

    if (onEditSuccessUpdateAlbum) {
      onEditSuccessUpdateAlbum(updatedAlbum);
    } else {
      updateAlbumsList(updatedAlbum);
    }

    setAlbumsData(updatedAlbums);
  };

  const hasInvalidatedValues = (
    albumId: number,
    toastrValue: boolean,
    value: string
  ) => {
    const albumName =
      value !== undefined && value !== null ? value : albumNameDrafts[albumId];
    const editInputContainer = document.querySelector(".ws-edit-album-name");
    if (!validateName(albumName) && editInputContainer) {
      //@ts-ignore
      editInputContainer.style.outline = "red 1px solid";
      if (toastrValue) {
        //@ts-ignore
        toastr.error(restrictedTermsError);
      }
      return true;
    }
    if (albumName.trim() === "" && editInputContainer) {
      //@ts-ignore
      editInputContainer.style.outline = "red 1px solid";
      if (toastrValue) {
        //@ts-ignore
        toastr.error("Please enter a name");
      }
      return true;
    }
    if (
      validateName(albumName) &&
      albumName.trim() !== "" &&
      editInputContainer
    ) {
      //@ts-ignore
      editInputContainer.style.outline = "";
    }
    return false;
  };

  const updateDraftName = (e: any, albumId: number, value: string) => {
    e.stopPropagation();
    setAlbumNameDrafts(prev => ({
      ...prev,
      [albumId]: value
    }));
    hasInvalidatedValues(albumId, false, (e.target as HTMLInputElement).value);
  };

  const handleKeyDownAction = (e: any, album: Album) => {
    if (e.key === "Enter") {
      e.preventDefault();
      if ((e.target as HTMLInputElement).value.trim() !== "") {
        const onEditSuccessWrapper = (updatedData: Album | Album[]) => {
          onEditSuccess(updatedData, album.id);
        };

        submitAlbumName(
          e,
          album.id,
          albumNameDrafts[album.id],
          hasInvalidatedValues,
          setAlbumNameDrafts,
          setAlbumsInEditMode,
          onEditSuccessWrapper,
          albumsData || []
        );
      } else {
        hasInvalidatedValues(
          album.id,
          true,
          (e.target as HTMLInputElement).value
        );
      }
    }
  };

  const submitNameChange = async (e: any, album: Album) => {
    if (albumNameDrafts[album.id]?.trim() !== "") {
      const onEditSuccessWrapper = (updatedData: Album | Album[]) => {
        onEditSuccess(updatedData, album.id);
      };

      await submitAlbumName(
        e,
        album.id,
        albumNameDrafts[album.id],
        hasInvalidatedValues,
        setAlbumNameDrafts,
        setAlbumsInEditMode,
        onEditSuccessWrapper,
        albumsData || []
      );
    } else {
      hasInvalidatedValues(album.id, true, albumNameDrafts[album.id]);
    }
  };

  return {
    albumsInEditMode,
    albumNameDrafts,
    toggleEditMode,
    updateDraftName,
    handleKeyDownAction,
    submitNameChange,
    hasInvalidatedValues
  };
};
